import { render } from "./Family-member--personal-details.vue?vue&type=template&id=14179a56"
import script from "./Family-member--personal-details.vue?vue&type=script&lang=ts"
export * from "./Family-member--personal-details.vue?vue&type=script&lang=ts"
script.render = render

export default script